import { getLatestComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestUpdates() {
  const comics = getLatestComics();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-6 md:mb-8">
          <p className="text-xs text-foreground-500 font-medium uppercase tracking-wider">最新更新</p>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
            追更不停歇
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg">
            每日更新热门韩漫，精彩剧情不容错过
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {comics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}